define(function (require) {
    "use strict";

    var TicketListItemView = require("connection-views/ticketTab/TicketListItemView"),
        Template = require("connection-templates/ticketTab/ticketsSnippetsCompositeView.tmpl"),
        TicketsSnippetsCompositeView = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketsSnippetsCompositeView = Marionette.CompositeView.extend({
            itemView: TicketListItemView,
            template: Template,
            className: "ticket-snippet-composite-view",
            ui: {
                ticketListTitle: ".separator-title-text"
            },

            initialize: function (options) {
                options = options || {};
                this.itemViewOptions = {
                    type: options.type
                };
            }

        });
    });

    return TicketsSnippetsCompositeView;


});

